import React from 'react';
import {hyperlinkRegex} from '../../../../Util/HyperlinkRegex';
import {Box} from '@mui/material';

type Props = {
  contentText: string;
};

//Legacy. Used for old content
export default function POCToolParagraphContent(props: Props) {
  const {contentText} = props;
  const parts = contentText.split(hyperlinkRegex);
  // we split the text into parts of 4
  // the first part is the text before the hyperlink
  // the second part is the hyperlink text
  // the third part is the hyperlink
  // the fourth part is the text after the hyperlink

  function TextContent() {
    if (parts.length > 1) {
      const elements = [];
      for (let index = 0; index < parts.length - 1; index += 3) {
        // index += 3 because we want to skip the ${} and () parts
        elements.push(
          <p key={index.toString()} style={styles.textStyle}>
            {index === 0 && parts[index]}
            <a
              style={styles.linkStyle}
              onClick={() => window.open(parts[index + 2], '_blank')}>
              {parts[index + 1]}
            </a>
            {parts[index + 3]}
          </p>,
        );
      }
      return <Box>{elements}</Box>;
    } else {
      return <p style={styles.textStyle}>{contentText}</p>;
    }
  }
  return <TextContent />;
}

const styles = {
  linkStyle: {
    color: 'blue',
    textDecorationLine: 'underline',
    fontSize: 16,
    fontWeight: '400',
    cursor: 'pointer',
  },
  textStyle: {
    fontSize: 16,
    fontWeight: '400',
    marginBottom: 5,
    marginTop: 10,
  },
};
